import { render, staticRenderFns } from "./03_address.vue?vue&type=template&id=784dd879"
import script from "./03_address.vue?vue&type=script&lang=js"
export * from "./03_address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports